

















import Vue from "vue";

export default Vue.extend({
  name: "FlyerModalPopup",
  data() {
    return {
      showModal: false
    };
  },
  created() {
    // Show on home page every time (no session restriction)
    const currentPath = this.$route.path;
    if (currentPath === "/home" || currentPath === "/" || currentPath === "") {
      setTimeout(() => {
        this.showModal = true;
      }, 1500);
    }
  },
  methods: {
    closeModal() {
      this.showModal = false;
    },
    openSurvey() {
      window.open("https://www.surveymonkey.com/r/HSJKCWK", "_blank");
    }
  }
});
